export default __webpack_public_path__ + "2375a46554c298b5db2e73a2e3f2c55c.png";